import { render, staticRenderFns } from "./BaseInformationStep.vue?vue&type=template&id=3e13fa85&scoped=true&"
import script from "./BaseInformationStep.vue?vue&type=script&lang=ts&"
export * from "./BaseInformationStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e13fa85",
  null
  
)

export default component.exports